import React, { useEffect, useState, useMemo } from "react";
import { Form, Col } from "react-bootstrap";
import { mapUserRoles } from "../../../functions/useRoleMapping";
import { useSelector } from "react-redux";
import useHandleBlur from "../../../functions/useHandleBlur";
import useTbdCheck from "../../../functions/useTbdCheck";
import { useFormState } from "../../../functions/useFormState"; // Reusable form hook
import {
  selectUserDetails,
  selectUserRoles,
} from "../../../redux/slices/userSlice";
import { selectApiUrls } from "../../../redux/slices/apiUrlSlice";
import { selectOwnersManual } from "../../../redux/selectors";

function SalesComments(zone) {
  const userDetails = useSelector(selectUserDetails); // User details
  const userRoles = useSelector(selectUserRoles); // User details
  const currentUser = userDetails?.name;
  const sectionName = "ownersManual";

  const apiUrls = useSelector(selectApiUrls); // Fetch API URLs from Redux
  const apiUrl = apiUrls[sectionName];
  const tableKey = sectionName;

  const error = null;
  const loading = false;

  const storedJobDetails = useSelector(selectOwnersManual);
  const jobDetails = useMemo(() => {
    return storedJobDetails[0] || {};
  }, [storedJobDetails]);

  const { formData, handleChange, setFormData } = useFormState({}); // Form state management

  useEffect(() => {
    if (jobDetails) {
      setFormData({
        ID: jobDetails.ID || "",
        comments: jobDetails.Comments || "",
      });
    }
  }, [jobDetails, setFormData]);

  const jobCheckoutStatus = useSelector((state) => state.checkout.job);
  const isJobCheckedOut = jobCheckoutStatus?.IsCheckedOut === true;
  const isCurrentUserCheckedOut =
    jobCheckoutStatus?.CheckedOutBy === currentUser;
   const readOnly = useSelector((state) => state.readOnly.isReadOnly); // Fetch read-only state from Redux
   const isDisabled = (isJobCheckedOut && !isCurrentUserCheckedOut) || readOnly; // Update isDisabled condition;

  // State to store role variables
  const [roles, setRoles] = useState({
    Admin: false,
    Apps: false,
    Engineer: false,
    TestPit: false,
    PSN: false,
    Sales: false,
    ReadOnly: false,
  });

  const { handleFocus, handleBlur, showNotification, saveStatus } =
    useHandleBlur(formData);

  useEffect(() => {
    setRoles(mapUserRoles(userRoles));
  }, [userRoles]);

  const { tbdFields } = useTbdCheck(formData, zone); // Pass zone to track TBD status for specific zone
  const zoneTbdFields = zone ? tbdFields?.[zone] : tbdFields;

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center">
      <div className="spinner-border" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      </div>
    ); // Show loading spinner
  }

  if (error) {
    return <div className="error">{error}</div>; // Show error message if fetch fails
  }

  return (
    <div>
      {error ? (
        <p style={{ color: "red" }}>Error: {error}</p>
      ) : !formData ? (
        <p>Loading...</p>
      ) : (
        <div>
          <div>
            {showNotification && (
              <div
                className={`save-notification ${
                  saveStatus.includes("Failed") ? "error" : ""
                }`}
              >
                {saveStatus}
              </div>
            )}
          </div>
          <div>
            <Col className="flex-grow-3">
              <Form.Group controlId="comments">
                <Form.Label>Comments</Form.Label>
                <Form.Control
                  as="textarea"
                  name="comments"
                  value={formData.comments}
                  onFocus={handleFocus}
                  onBlur={(e) =>
                    handleBlur(e, "Comments", [], {
                      ID: formData.ID,
                      url: apiUrl,
                      field: "Comments",
                      tableKey: tableKey,
                    })
                  }
                  disabled={isDisabled || (!roles.Admin && !roles.Apps)}
                  className={zoneTbdFields?.comments ? "tbd-highlight" : ""}
                  onChange={handleChange}
                  placeholder="Enter Comments"
                  rows={3}
                />
              </Form.Group>
            </Col>
          </div>
        </div>
      )}
    </div>
  );
}

export default SalesComments;
